module.exports = __webpack_public_path__ + "img/3.be4f5552.svg";